import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProfileProvider, useVenueProfile } from './profile-context';
import { BookingFlowPage } from './pages/BookingFlowPage';
import { TakeoutPage } from './pages/TakeoutPage';
import { ReservationStatusPage } from './pages/ReservationStatusPage';

/**
 * Root redirect logic: guests land on the booking flow directly — no
 * separate "welcome" screen. A takeout-only venue (no bookable zones)
 * lands on /takeout instead so the root URL is never a dead end.
 *
 * If a venue has neither, we fall through to the booking flow, which
 * renders an empty-zone notice rather than a blank page.
 */
function RootRedirect(): JSX.Element {
  const profile = useVenueProfile();
  const hasBookableZones = profile.zones.some((z) => z.scenarioType !== 'PICKUP_ORDER');
  if (!hasBookableZones && profile.capabilities.publicPortal.showTakeoutForm) {
    return <Navigate to="/takeout" replace />;
  }
  return <BookingFlowPage />;
}

export function AppRouter(): JSX.Element {
  return (
    <BrowserRouter>
      <ProfileProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/book" element={<Navigate to="/" replace />} />
          <Route path="/takeout" element={<TakeoutPage />} />
          <Route path="/reservations/:token" element={<ReservationStatusPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ProfileProvider>
    </BrowserRouter>
  );
}
